import { useState } from 'react'
import Select, { ClassNamesConfig, GroupBase, MenuListProps } from 'react-select'
import useInit from './hooks/useInit'
import getRows from './utils/getRows'
import useFilterRoleChange from './hooks/useFilterRoleChange'
import { selectClassNames } from 'shared/assets/conf'
import PerfectScrollbar from 'react-perfect-scrollbar'
import 'react-perfect-scrollbar/dist/css/styles.css'

interface HeaderFilterRoleSelectProps {
  setShowOverlay?: Function
  handleFilterRoleChanged?: Function
  filterRoleName: any
}

const HeaderFilterRoleSelect: React.FunctionComponent<HeaderFilterRoleSelectProps> = (
  props: HeaderFilterRoleSelectProps,
) => {
  const [rows, setRows] = useState<any>([])
  const [dataLoaded, setDataLoaded] = useState<boolean>(false)
  const [initialRender, setInitialRender] = useState<boolean>(true)
  const [currentFilterRole, setCurrentFilterRole] = useState<{} | null>(null)

  useInit({
    getRows,
    setRows,
    setCurrentFilterRole,
    setDataLoaded,
    filterRoleName: props.filterRoleName.name,
  })

  useFilterRoleChange({
    currentFilterRole,
    initialRender,
    dataLoaded,
    setInitialRender,
    handleFilterRoleChanged: props.handleFilterRoleChanged,
  })

  const handleFilterRoleChange = (value) => {
    if (currentFilterRole !== value) {
      if (props.setShowOverlay !== undefined) {
        // props.setShowOverlay(true)
      }
      setCurrentFilterRole(value)
    }
  }

  if (currentFilterRole === null) {
    handleFilterRoleChange(rows[0])
  }

  const MenuList = (props: MenuListProps<any, false, any>) => {
    return (
      <div>
        <PerfectScrollbar style={{ background: 'transparent' }}>{props.children}</PerfectScrollbar>
      </div>
    )
  }

  const classsNames: ClassNamesConfig<any, boolean, GroupBase<any>> = {
    ...selectClassNames,
    container: (state) => 'select-container me-lg-3',
  }

  return (
    <>
      {dataLoaded && rows.length > 1 && (
        <>
          <label>Role</label>
          <Select
            classNames={classsNames}
            components={{ MenuList }}
            options={rows}
            defaultValue={currentFilterRole}
            getOptionLabel={(option) => option.name}
            getOptionValue={(option) => option.id}
            isClearable={false}
            onChange={(value) => handleFilterRoleChange(value)}
          />
        </>
      )}

      {!dataLoaded && rows.length > 1 && (
        <>
          <label>Showing</label>
          <Select
            classNames={selectClassNames}
            options={[
              {
                value: 0,
                label: props.filterRoleName.name,
              },
            ]}
            defaultValue={{
              value: 0,
              label: props.filterRoleName.name,
            }}
          />
        </>
      )}
    </>
  )
}

export default HeaderFilterRoleSelect
